<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
        <div class="btn-box">
          <el-date-picker
            v-model="timeValue"
            type="daterange"
            :picker-options="pickerOptions2"
            size="small"
            unlink-panels
            @change="changeTimeValue"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="btn-box">
          <input-select selectTitle="报名状态" :selectKey="'applyStatus'" :selectData="applyStatusList" @search="search" style="margin-left: 10px;"/>
        </div>
        <div class="btn-box">
          <input-search placeholder="人员姓名" @search="searchKey" />
        </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/activity";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "activity-consumption-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧活动",
          name: "activity-manage"
        },
        {
          value: "报名记录"
        }
      ],
      timeValue: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      exportUrl: "",
      applyStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "2",
          label: "报名成功"
        },
        {
          key: "3",
          label: "取消报名"
        }
      ],
      payStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "未缴费"
        },
        {
          key: "2",
          label: "已缴费"
        }
      ],
      payChannelList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "其他"
        }
      ],
      tableHead: [
        {
          prop: "personName",
          label: "人员姓名"
        },
        {
          prop: "personPhone",
          label: "人员手机号"
        },
        {
          prop: "enterpriseName",
          label: "住户名称"
        },
        {
          prop: "eventName",
          label: "活动名称"
        },
        {
          prop: "applyTime",
          label: "报名时间"
        },
        {
          prop: "applyStatusText",
          label: "报名状态",
          showColor: true
        },
        {
          prop: "checkInStatusText",
          label: "签到状态",
          showColor2: true
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        applyStatus: "",
        searchKey: ""
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreatTime();
  },
  activated() {
    this.getPage()
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportRepairPayRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&payStatus=${this.requestData.payStatus}`;
    },
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-01";
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue && this.timeValue.length > 0) {
        reqData.startTime = `${this.timeValue[0]} 00:00:00`;
        reqData.endTime = `${this.timeValue[1]} 23:59:59`;
      } else {
        reqData.startTime = "";
        reqData.endTime = "";
      }
      this.$axios
        .post(api.getRegistrationRecordPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.applyStatus === "1") {
                v.applyStatusText = "等待缴费";
              } else if (v.applyStatus === "2") {
                v.applyStatusText = "报名成功";
                v.fontColorToPeople = "#18887B";
                v.backgroundColor = "#E4F0EF";
              } else if (v.applyStatus === "3") {
                v.applyStatusText = "取消报名";
                v.fontColorToPeople = "#8B36EF";
                v.backgroundColor = "#F1E8FC";
              }
              if (v.checkInStatus) {
                v.checkInStatusText = "已签到";
                v.fontColorToPeople2 = "#18887B";
                v.backgroundColor2 = "#E4F0EF";
              } else {
                v.checkInStatusText = "未签到";
                v.fontColorToPeople2 = "#8B36EF";
                v.backgroundColor2 = "#F1E8FC";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/Activity/RegistrationRecord/RegistrationRecord.vue